import React from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/react-hooks";
import { Box, Button, Typography } from "@mui/material";
import { MY_HR_CLEAN_CACHE } from "my-hr/graphql";
import { OcCard } from "oc/components";
import { useOcSnackbar } from "oc/hooks";

export const MyHrSystemSettingsCacheCard = () => {
  const { t } = useTranslation();

  const { setOpenMessage } = useOcSnackbar();

  const [cleanCache] = useMutation(MY_HR_CLEAN_CACHE, {
    onCompleted(data) {
      if (data.cleanCache) {
        setOpenMessage({
          type: "success",
          message: t("MY_HR_CLEAR_CACHE_SUCCEEDED"),
        });
      }

      // TODO: Implement notifications?
    },
    onError(err) {
      console.log(err);
    },
  });

  const handleClearCache = () => {
    cleanCache();
  };

  return (
    <OcCard label={t("MY_HR_CLEAR_CACHE")}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        padding="16px 0px"
      >
        <Button
          id="clear-cache-buttom"
          variant="contained"
          disableElevation
          color="primary"
          onClick={handleClearCache}
        >
          {t("MY_HR_CLEAR_CACHE")}
        </Button>
        <Box padding="32px 0px 0px 0px">
          <Typography variant="caption">{t("MY_HR_CLEAR_CACHE_TEXT")}</Typography>
        </Box>
      </Box>
    </OcCard>
  );
};

export default MyHrSystemSettingsCacheCard;
